<template>
  <div>
    <b-row class="match-height">
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          class="card-tiny-line-stats"
        >
          <h6 class="mb-2">
            Total Brand
          </h6>
          <b-media no-body>
            <b-media-aside
              class="mr-1"
            >
              <b-avatar
                size="36"
                variant="light-primary"
              >
                <feather-icon
                  size="20"
                  icon="ShoppingBagIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h1 class="font-weight-bolder mb-0">
                {{ toThousands(brandGrowth.statistic[0] ? brandGrowth.statistic[brandGrowth.statistic.length - 1].z : 0) }}
              </h1>
              <b-card-text class="font-small-3 mb-0">
                brand
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="9"
      >
        <BrandGrowthChart
          :chart-data="brandGrowth.statistic"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <div
          class="card mb-0"
          style="border-bottom-left-radius: 0; border-bottom-right-radius: 0"
        >
          <b-tabs
            v-model="tabIndex"
            class="mb-0"
            nav-class="mb-0"
          >
            <b-tab
              title="Brand Leaderboard"
            />
            <b-tab
              title="Penjualan Per Brand"
            />
            <b-tab
              title="Produk Terjual"
            />
          </b-tabs>
        </div>

        <TopBrandSales
          v-if="tabIndex === 0"
          class="pt-0"
        />

        <BrandSales
          v-if="tabIndex === 1"
          class="pt-0"
        />

        <TransactionItem
          v-if="tabIndex === 2"
          class="pt-0"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BrandGrowthChart from '@/layouts/components/chart/BrandGrowthChart.vue'
import TopBrandSales from '@/layouts/components/report/TopBrandSales.vue'
import BrandSales from '@/layouts/components/report/BrandSales.vue'
import TransactionItem from '@/layouts/components/report/TransactionItem.vue'

import {
  BMedia,
  BTabs,
  BTab,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BrandGrowthChart,
    BrandSales,
    TopBrandSales,
    TransactionItem,
    BTabs,
    BTab,
    BAvatar,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BRow,
    BCol,
  },
  data() {
    return {
      tabIndex: 0,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('brand', ['brandGrowth']),
  },
  async created() {
    this.isLoading = true
    const { startDate, endDate } = this.getFirstLastDate() // <- from global mixins
    await this.getBrandGrowth({ startDate, endDate })
    this.isLoading = false
  },
  methods: {
    ...mapActions('brand', ['getBrandGrowth']),
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      }
      return ['bg-light', 'text-info']
    },
  },
}
</script>
